import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";
import { BetterAuthError } from "../utils";
import { SSO_PROVIDERS_QUERY_KEY } from "./useSsoProviders";

type DeleteSsoProviderInput = {
  providerId: string;
};

export function useDeleteSsoProvider(
  options?: UseMutationOptions<unknown, BetterAuthError, DeleteSsoProviderInput, unknown>,
) {
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options ?? {};

  return useMutation({
    ...rest,
    mutationFn: async ({ providerId }: DeleteSsoProviderInput) => {
      const { data, error } = await authClient.sso.deleteProvider({ providerId });
      if (error) {
        throw new Error(betterAuthErrorText(error, "Could not delete SSO provider"));
      }
      return data;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: SSO_PROVIDERS_QUERY_KEY,
        refetchType: "all",
      });
      onSuccess?.(...args);
    },
  });
}
